import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';



Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#015a95',
        secondary: '#018894',
        accent: '#018894',
        error: '#b71c1c',
      },
    },
  },
})
  
  export default vuetify
  
  